import React from "react";
import classNames from "classnames";

import "./styles.styl";
import LocationPicker from "../location-picker/LocationPicker.jsx";
import CalendarIcon from "../calendar/Calender";
import { useIntl } from "react-intl";
import { MOBILE_BREAKPOINT } from "../../util/constants.js";

export default function CartHeader(props) {
  const intl = useIntl();
  const {
    delivery,
    address,
    message,
    cardHeaderRef,
    onClick,
    onDateClick,
    openSettingsOrTab,
  } = props;
  const isDesktop = window.innerWidth > MOBILE_BREAKPOINT;
  const welcomeTime =
    delivery?.timeframe_short && delivery?.delivery_date
      ? `${delivery.timeframe_short}, ${delivery.delivery_date}`
      : intl.formatMessage({ id: "selectDeliveryTime" });

  return (
    <div
      className={classNames("cart-header", { "sticky-cart-header": isDesktop })}
      ref={cardHeaderRef}
      onClick={onClick}
    >
      {message && <div className="cart-header__message"> {message} </div>}
      <div className="cart-header__pickers">
        <LocationPicker pickup={address} className="location-picker" />
        <DeliveryDateInput
          welcomeTime={welcomeTime}
          onDateClick={onDateClick}
          openSettingsOrTab={openSettingsOrTab}
        />
      </div>
    </div>
  );
}

const DeliveryDateInput = ({ welcomeTime, onDateClick, openSettingsOrTab }) => {
  return (
    <div
      onClick={onDateClick ? onDateClick : () => openSettingsOrTab(2, true)}
      className="delivery-date-input"
    >
      <p className="delivery-date-input_text">{welcomeTime}</p>
      <CalendarIcon />
    </div>
  );
};
